module.exports = __webpack_public_path__ + "static/media/Stare_vinice.60de3d47.md";